import React from "react"

function DematchingSkeletonCard({ variant = "foreign" }) {
    const isMaster = variant === "customer"

    return (
        <div
            className={
                "pp-matching-skeleton-card" + (isMaster ? " pp-matching-skeleton-card--master" : "")
            }
        >
            <div className="pp-matching-card-row">
                <div
                    className={
                        "pp-matching-skeleton__image " +
                        (isMaster ? "pp-matching-product-img--master" : "pp-matching-product-img--candidate")
                    }
                />
                <div className="pp-matching-card-row__content">
                    <div className="pp-matching-skeleton__line pp-matching-skeleton__line--title" />
                    <div className="pp-matching-skeleton__line pp-matching-skeleton__line--meta" />
                    <div className="pp-matching-skeleton__line pp-matching-skeleton__line--meta pp-matching-skeleton__line--short" />
                    <div className="pp-matching-skeleton__line pp-matching-skeleton__line--price" />
                </div>
            </div>
        </div>
    )
}

function DematchingPairSkeletonRow() {
    return (
        <div className="pp-dematching-pair pp-dematching-pair--skeleton" aria-hidden="true">
            <div className="pp-dematching-pair__customer">
                <DematchingSkeletonCard variant="customer" />
            </div>
            <div className="pp-dematching-pair__chain-wrap">
                <div className="pp-dematching-skeleton-chain" />
            </div>
            <div className="pp-dematching-pair__foreign">
                <DematchingSkeletonCard variant="foreign" />
            </div>
        </div>
    )
}

export default function PPDematchingPairsSkeleton({ rowCount = 4 }) {
    return (
        <div className="pp-dematching-pairs-skeleton" aria-busy="true" aria-live="polite">
            {Array.from({ length: rowCount }, (_, index) => (
                <DematchingPairSkeletonRow key={index} />
            ))}
        </div>
    )
}
